import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import { scrollToSection } from './SmoothScroll';

const LOGO_URL = '/img/logo-wingfold.png';

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/5'
          : 'bg-transparent'
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex items-center justify-between">
        <button
          onClick={() => scrollToSection()}
          className="flex items-center gap-3 group"
          data-testid="navbar-logo"
        >
          <img 
            src={LOGO_URL} 
            alt="Wingfold" 
            className="h-11 w-11 object-contain transition-transform group-hover:scale-105"
            style={{ filter: 'brightness(1.05) contrast(1.05)' }}
          />
          <span className="font-display text-xl font-medium tracking-tight text-white group-hover:text-gold transition-colors hidden sm:block">
            Wingfold
          </span>
        </button>
        
        <div className="hidden md:flex items-center gap-10">
          <button
            onClick={() => scrollToSection('servicios')}
            className="font-sans text-sm text-white/60 hover:text-white transition-colors relative group"
            data-testid="nav-servicios"
          >
            Servicios
            <span className="absolute -bottom-1 left-0 w-0 h-px bg-gold group-hover:w-full transition-all duration-300" />
          </button>
          <button
            onClick={() => scrollToSection('nosotros')}
            className="font-sans text-sm text-white/60 hover:text-white transition-colors relative group"
            data-testid="nav-nosotros"
          >
            Nosotros
            <span className="absolute -bottom-1 left-0 w-0 h-px bg-gold group-hover:w-full transition-all duration-300" />
          </button>
          <button
            onClick={() => scrollToSection('contacto')}
            className="px-5 py-2.5 bg-gold text-black text-sm font-semibold rounded-full hover:bg-gold-400 transition-all duration-300 gold-glow"
            data-testid="nav-contacto"
          >
            Contacto
          </button>
          <a
            href="https://wa.me/34625833080?text=Hola%20Wingfold!%20Vi%20t%C3%BA%20p%C3%A1gina%20web%20y%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n."
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-10 h-10 rounded-full bg-[#25D366] hover:bg-[#20BA5A] transition-colors duration-300"
            data-testid="nav-whatsapp"
            aria-label="WhatsApp"
          >
            <FaWhatsapp className="w-5 h-5 text-white" />
          </a>
        </div>
      </div>
    </motion.nav>
  );
};
